var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 17,
    viewBox: "0 0 20 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 0H5C2 0 0 1.49701 0 4.99002V11.976C0 15.4691 2 16.9661 5 16.9661H15C18 16.9661 20 15.4691 20 11.976V4.99002C20 1.49701 18 0 15 0ZM15.47 6.07784L12.34 8.57285C11.68 9.1018 10.84 9.36128 10 9.36128C9.16 9.36128 8.31 9.1018 7.66 8.57285L4.53 6.07784C4.21 5.81836 4.16 5.33932 4.41 5.01996C4.67 4.7006 5.14 4.64072 5.46 4.9002L8.59 7.39521C9.35 8.00399 10.64 8.00399 11.4 7.39521L14.53 4.9002C14.85 4.64072 15.33 4.69062 15.58 5.01996C15.84 5.33932 15.79 5.81836 15.47 6.07784Z",
    fill: "#45436B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.e66bba809b5705299e76d3bbd9255f66.svg";
export { ForwardRef as ReactComponent };